import React, { useState } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import s from './forget-password.module.scss'
import { FormProvider, useForm } from 'react-hook-form';
import { Input } from '@shared/ui/input/input';
import { Button } from '@shared/ui/button/button';
import { ActionsWrapper, AuthAction } from '../actions-wrapper/actions-wrapper';
 
const errors = {
	401: 'Аккаунта с такой почтой не существует',
}

export const ForgetPassword = () => {
	const methods = useForm({mode: 'onTouched'})
	const [error] = useState()
	const navigate = useNavigate()

  const handleSubmit = methods.handleSubmit(data => {
		navigate('/waiting-restore', {
			state: {
				verifyPhone: data?.phone
			}
		})
  })

	return (
		<div className={s.wrapper}>
			<div className={s.card}>
				{/* <NavLink to={'/'} className={s.logo}>
					<img src={process.env.REACT_APP_STORAGE_URL + "images/logo.svg"} alt="Созвучно - сервис по поиску преподавателей музыки"/>
				</NavLink> */}
				<h2 className={s.title}>
					Восстановление пароля
				</h2>
				<ActionsWrapper>
					<AuthAction>
						Вспомнили пароль?
						<NavLink to={'/login'}> Войти</NavLink>
					</AuthAction>
				</ActionsWrapper>
				{error && <span className={s.error}>{errors[error?.status]}</span>}				
				<FormProvider {...methods}>
					<form onSubmit={handleSubmit} className={s.form}>
						<Input
							placeholder='+7(999) 999 99-99' 
							name='phone' 
							className={s.input}
							title='Ваш телефон'
							mask="+9(999) 999-99-99"
							validation={{
									required: 'Телефон обязателен',
									pattern: {
										value: /^\+\d\(\d{3}\) \d{3}-\d{2}-\d{2}$/,
										message: 'Неверный формат телефона',
									},
							}}/>
						
						<Button label='Восстановить' className={s.button}/>
					</form>
				</FormProvider>
			</div>
		</div>
	)
}
